//gsap
import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);
export function blockLogosSlider() {
  document.addEventListener("DOMContentLoaded", function () {
    const tracks = document.querySelectorAll(".blockLogosSlider__track");

    if (!tracks.length) return;
    tracks.forEach((track) => {
      //position start, shaking reduction
      gsap.set(track, { x: 0, rotation: 0.01, force3D: true });
      const itemsCount = track.children.length;

      // base time for one element
      const baseDurationPerItem = 3;

      // dynamic animation time
      const dynamicDuration = itemsCount * baseDurationPerItem;
      const animation = gsap.to(track, {
        xPercent: -50, // Shifting exactly one set of logos
        ease: "none",
        duration: dynamicDuration,
        repeat: -1,
      });

      ScrollTrigger.create({
        trigger: "body",
        start: "top top",
        end: "bottom bottom",
        onUpdate: (self) => {
          const velocity = Math.abs(self.getVelocity() / 400);

          gsap.to(animation, {
            timeScale: 1 + velocity,
            duration: 0.3,
            overwrite: "auto",
          });

          gsap.to(animation, {
            timeScale: 1,
            duration: 1.2,
            ease: "power2.inOut",
            overwrite: false,
          });
        },
      });
    });
  });
}
